import { useState, useCallback } from 'react'

/**
 * Hook personnalisé pour gérer les formulaires
 * @param {Object} initialValues - Valeurs initiales du formulaire
 * @returns {Object} Valeurs, gestionnaires et méthodes utilitaires
 */
export const useForm = (initialValues = {}) => {
  const [values, setValues] = useState(initialValues)
  const [errors, setErrors] = useState({})
  const [touched, setTouched] = useState({})

  /**
   * Gère le changement d'une valeur dans le formulaire
   */
  const handleChange = useCallback((e) => {
    const { name, value, type, checked } = e.target
    setValues((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }, [])

  /**
   * Gère le changement d'une valeur personnalisée
   */
  const setValue = useCallback((name, value) => {
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }))
  }, [])

  /**
   * Gère le blur d'un champ
   */
  const handleBlur = useCallback((e) => {
    const { name } = e.target
    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }))
  }, [])

  /**
   * Définit une erreur pour un champ spécifique
   */
  const setFieldError = useCallback((name, error) => {
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }))
  }, [])

  /**
   * Réinitialise le formulaire
   */
  const reset = useCallback(() => {
    setValues(initialValues)
    setErrors({})
    setTouched({})
  }, [initialValues])

  /**
   * Réinitialise avec de nouvelles valeurs
   */
  const resetWith = useCallback((newValues) => {
    setValues(newValues)
    setErrors({})
    setTouched({})
  }, [])

  return {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setValue,
    setFieldError,
    setValues,
    setErrors,
    reset,
    resetWith,
  }
}
